import { Reveal, stagger, item } from "./motion";
import { motion } from "framer-motion";
import { PUBLICATIONS, JOURNALS, IMAGES } from "@/data";
import { FileText, BookOpen } from "lucide-react";

export const Research = () => (
  <section id="research" className="py-24 sm:py-32 scroll-mt-24" data-testid="research">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="overline text-[#B9735A] mb-5">Research & Academics</p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl text-[#1A1C1A] tracking-tight">
            Advancing the <span className="italic text-[#B9735A]">science</span> of care
          </h2>
          <p className="mt-6 text-[#4A4D4A] leading-relaxed">
            Special interests in uterine and ovarian cancers, minimally invasive gynecologic oncology,
            sentinel lymph node mapping, lower-limb lymphedema, precision oncology, survivorship and
            quality-of-life research.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 rounded-3xl overflow-hidden border border-black/5 shadow-lg">
            <img src={IMAGES.lab} alt="Research" className="w-full h-56 object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8">
            <div className="flex items-center gap-2 text-[#6B7A6A] mb-3">
              <BookOpen size={16} /><p className="overline">Published In</p>
            </div>
            <ul className="space-y-2">
              {JOURNALS.map((j) => (
                <li key={j} className="text-sm text-[#4A4D4A] border-l-2 border-[#6B7A6A]/30 pl-3">{j}</li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <div className="flex items-center gap-2 text-[#B9735A] mb-5">
            <FileText size={16} /><p className="overline">Selected Publications</p>
          </div>
        </Reveal>
        <motion.ol
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="space-y-3"
        >
          {PUBLICATIONS.map((p, i) => (
            <motion.li
              key={p.title}
              variants={item}
              className="group rounded-2xl border border-black/5 bg-white p-6 flex gap-5 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300"
              data-testid={`publication-${i}`}
            >
              <span className="font-serif-display text-2xl text-[#B9735A]/60 shrink-0 w-8">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <p className="text-[#1A1C1A] leading-snug group-hover:text-[#B9735A] transition-colors">{p.title}</p>
                <span className="mt-2 inline-block text-xs font-semibold tracking-wide uppercase text-[#6B7A6A]">
                  {p.tag}
                </span>
              </div>
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </div>
  </section>
);
